import React from 'react'
import { Button, Table, TableFiltering, BreadcrumbGroup } from 'AWS-UI-Components-React'
import { COLUMN_DEFINITIONS, LOADING_TEXT, BREADCRUMB_ITEMS } from './ContractsListConstants'
import './ContractsListView.css'

export default class ContractsView extends React.Component {

    render() {
        return (
            <div>
                <BreadcrumbGroup label="Breadcrumbs" items={BREADCRUMB_ITEMS}></BreadcrumbGroup>
                <Table
                    loadingText={LOADING_TEXT}
                    columnDefinitions={COLUMN_DEFINITIONS}
                    loading={!this.props.contractsLoadDone}
                    items={this.formatContracts(this.props.contracts).reverse()}
                    empty={this.renderEmptyTableMessage()}
                    noMatch={this.renderNoFilterMatchMessage()}
                    >
                    <TableFiltering></TableFiltering>
                    <Button id="create-contract-button" className="new-contract-btn awsui-util-mr-s" text="Create Contract" variant="primary" href="/#/contract/create"></Button>
                </Table>
            </div>
        )
    }

    renderEmptyTableMessage() {
        return (
            <div className="awsui-util-t-c">
                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                    <b> No contracts </b>
                </div>
                <p className="awsui-util-mb-s"> No contracts to display </p>
                <div className="awsui-util-mb-l">
                    <Button className="awsui-util-mb-l" text="Create contract"></Button>
                </div>
            </div>
        )
    }

    renderNoFilterMatchMessage() {
        return (
            <div className="awsui-util-t-c">
                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                    <b> No matches </b>
                </div>
                <p className="awsui-util-mb-s"> We can’t find a match. </p>
            </div>
        )
    }

    convertToUTC(date) {
        return new Date(date).toUTCString()
    }

    formatContracts(contracts) {
        return contracts.map(contract => {
            contract.createdAt = this.convertToUTC(contract.createdAt)
            contract.updatedAt = this.convertToUTC(contract.updatedAt)
            contract.active = contract.active ? "active" : ""
            return contract
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/List/ContractsListView.jsx